export var BrandCartEvents;
(function(BrandCartEvents) {
    BrandCartEvents[BrandCartEvents["GO_TO_BRAND_PAGE"] = 0] = "GO_TO_BRAND_PAGE";
    BrandCartEvents[BrandCartEvents["OPEN_PRODUCT_MODAL"] = 1] = "OPEN_PRODUCT_MODAL";
    BrandCartEvents[BrandCartEvents["CHANGE_CART_QUANTITY"] = 2] = "CHANGE_CART_QUANTITY";
    BrandCartEvents[BrandCartEvents["CHECKOUT"] = 3] = "CHECKOUT";
    BrandCartEvents[BrandCartEvents["CHECKOUT_ERROR"] = 4] = "CHECKOUT_ERROR";
    BrandCartEvents[BrandCartEvents["GO_TO_BAG"] = 5] = "GO_TO_BAG";
})(BrandCartEvents || (BrandCartEvents = {}));
